module.exports = __webpack_public_path__ + "img/gh2.3be9f3dd.png";